export { LOGIN_LANGUAGE as loginLanguage } from './texts'
